export default __webpack_public_path__ + "media/images/nav-arrow-587ccace84f8af47686d414ea9fb9a81.svg";